// @flow

import { hpfetch } from '../util';
import type { wrappedApiResponseType } from '../apiTypes';

export const getSingle = (id: number): Promise<wrappedApiResponseType<any>> =>
  hpfetch(`builds/${id}/`);

export const getMany = (
  limit: number = 100,
  offset: number = 0,
): Promise<wrappedApiResponseType<any>> =>
  hpfetch(`builds/?limit=${limit}&offset=${offset}`);
